const headerCrisisBar = (TheCrisisBar) => {
  if (TheCrisisBar) {
    TheCrisisBar.querySelector( '.crisis-bar__close' ).addEventListener( 'click', () => {
      TheCrisisBar.classList.add( 'crisis-bar--closed' );
      sessionStorage.setItem( 'crisisBarClosed', 'true' );
      document.body.classList.remove( 'crisis-bar-shown' );
    } );
    if (sessionStorage.getItem( 'crisisBarClosed' )) {
      TheCrisisBar.classList.add( 'crisis-bar--closed' );
    } else {
      document.body.classList.add( 'crisis-bar-shown' )
    }
  }
}

export default headerCrisisBar;